export const colors = [
	'rgb(60,180,75)',
	'rgb(0,0,128)',
	'rgb(230,25,75)',
	'rgb(245,130,48)',
	'rgb(100,151,177)',
	'rgb(170,255,195)',
	'rgb(230,190,255)',
	'rgb(128,128,128)',
	'rgb(128,0,0)',
	'rgb(255,225,25)',
	'rgb(0,130,200)',
	'rgb(250,190,190)',
	'rgb(128,128,0)',
	'rgb(0,0,0)',
	'rgb(210,45,60)',
	'rgb(70,240,240)',
	'rgb(0,130,200)',
	'rgb(145,30,180)',
	'rgb(240,50,230)',
	'rgb(170,110,40)',
	'rgb(255,215,180)',
	'rgb(255,250,200)',
	'rgb(178,216,216)', // Shades of Teal
	'rgb(102,178,178)',
	'rgb(0,128,128)',
	'rgb(0,102,102)',
	'rgb(0,76,76)',
	'rgb(150,206,180)', // Beach Colors
	'rgb(255,238,173)',
	'rgb(255,111,105)',
	'rgb(255,204,92)',
	'rgb(136,216,176)',
	'rgb(54,59,116)', // Twilight Sparkle
	'rgb(103,56,136)',
	'rgb(239,79,145)',
	'rgb(199,157,215)',
	'rgb(77,27,123)',
	'rgb(253,207,88)', // Fire
	'rgb(117,118,118)',
	'rgb(242,125,12)',
	'rgb(128,9,9)',
	'rgb(240,127,19)',
	'rgb(150,104,66)', // Instagram
	'rgb(244,71,71)',
	'rgb(238,220,49)',
	'rgb(127,219,106)',
	'rgb(14,104,206)',
	'rgb(0,0,95)', // Start 17 & jumped 4 for next color from https://jonasjacek.github.io/colors
	'rgb(0,0,215)',
	'rgb(0,95,135)',
	'rgb(0,135,0)',
	'rgb(0,135,215)',
	'rgb(0,175,135)',	
	'rgb(0,175,255)',
	'rgb(0,215,175)',
	'rgb(0,255,95)',
	'rgb(95,0,0)',
	'rgb(95,0,175)',
	'rgb(95,0,255)',
	'rgb(95,95,0)',
	'rgb(135,175,215)',
	'rgb(175,0,135)',
	'rgb(175,95,0)',
	'rgb(175,95,95)',
	'rgb(175,95,135)',
	'rgb(175,175,0)',
	'rgb(175,175,175)',
	'rgb(175,175,255)',
	'rgb(215,0,175)',
	'rgb(215,95,0)',
	'rgb(215,175,0)',
	'rgb(215,135,0)',
	'rgb(215,175,215)',
	'rgb(215,255,0)',
	'rgb(255,255,0)',
	'rgb(255,255,175)',
	'rgb(78,78,78)',
	'rgb(118,118,118)',
	'rgb(158,158,158)',
	'rgb(198,198,198)',
	'rgb(228,228,228)',

]